import * as auth from "./auth";

export const getHttpConfigWithToken = (headers = {}) => {
  const token = auth.getToken();

  return {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  };
};
